import React from 'react';
import { Link } from 'react-router-dom';
import './SubscriptionResult.css';

const SubscriptionCancel = () => {
  return (
    <div className="subscription-result">
      <div className="container">
        <div className="result-card cancel">
          <div className="result-icon">↩️</div>
          <h1>Checkout Cancelled</h1>
          <p className="result-message">
            No worries! Your subscription checkout was cancelled and you haven't been charged.
          </p>
          
          <div className="result-info">
            <p>You can still use all free features:</p>
            <ul>
              <li>✓ Generate unlimited bills of sale</li>
              <li>✓ Generate unlimited invoices</li>
              <li>✓ Download PDFs instantly</li>
            </ul>
          </div>
          
          <div className="result-actions">
            <Link to="/subscription" className="btn btn-primary btn-lg">
              View Plans Again
            </Link>
            <Link to="/bill-of-sale" className="btn btn-secondary btn-lg">
              Continue Free
            </Link>
          </div>
          
          <p className="help-text">
            Have questions? <a href="mailto:support@privatesold.com">Contact us</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
